<template>
  <div class="organization-seats-site-license-type-table-cell">
    <!-- SiteLicense -->
    <span v-if="billingType === 'SiteLicense'">
      <span class="label-student-licenses">
        Students: {{ usedStudentLicenses }} / {{ maxStudentLicenses }}
      </span>
      <span class="label-instructor-licenses">
        Instructors: {{ usedInstructorLicenses }} / {{ maxInstructorLicenses }}
      </span>
      <span class="label-admin-licenses">
        Admins: {{ usedAdminLicenses }} / {{ maxAdminLicenses }}
      </span>
    </span>

    <!-- POT or BillMeLater -->
    <span v-else-if="billingType === 'POT' || billingType === 'BillMeLater'">
      <span class="label-seats">
        Seats: {{ usedSeats }}/{{ maxSeats }} ({{ maxSeats - usedSeats }}
        available)
      </span>
    </span>

    <!-- StudentPays -->
    <span v-else>N/A</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@vue';

import type { Organization } from '@models';

/**
 * `TableCellOrganizationSeatsAndSiteLicenses` component properties.
 */
export interface Props {
  /** ... */
  item: Organization;
}

const props = defineProps<Props>();

const billingType = computed(() => props.item.billingType);

const maxStudentLicenses = computed(() => props.item.maxStudentLicenses);
const maxInstructorLicenses = computed(() => props.item.maxInstructorLicenses);
const maxAdminLicenses = computed(() => props.item.maxAdminLicenses);

const usedStudentLicenses = computed(() => props.item.usedStudentLicenses);
const usedInstructorLicenses = computed(
  () => props.item.usedInstructorLicenses,
);
const usedAdminLicenses = computed(() => props.item.usedAdminLicenses);

const usedSeats = computed(() => props.item.usedSeats);
const maxSeats = computed(() => props.item.maxSeats);
</script>

<script lang="ts">
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellOrganizationSeatsAndSiteLicenses: ComponentWithProps<Props>;
  }
}

export default { name: 'TableCellOrganizationSeatsAndSiteLicenses' };
</script>

<style lang="scss" scoped>
.organization-seats-site-license-type-table-cell {
  font-size: 12px;
}

.label-student-licenses {
  color: $role-pill-student-color;
  background-color: $role-pill-student-background;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
}

.label-instructor-licenses {
  color: $role-pill-instructor-color;
  background-color: $role-pill-instructor-background;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
}

.label-admin-licenses {
  color: $role-pill-institution-admin-color;
  background-color: $role-pill-institution-admin-background;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
}

.label-seats {
  color: #292929;
  background-color: #d0d0d0;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 10px;
}
</style>
